// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__vf5Fz","log":"ModalInventoryLogs_log__1OiQx","date":"ModalInventoryLogs_date__3VSDE","userName":"ModalInventoryLogs_userName__25x-L"};